export default __webpack_public_path__ + "static/moment_3-104af5030a615781280fcdbe742ebbe0.jpg";